const localeMap: Record<string, string> = {
  da: 'da-DK',
  en: 'en-GB',
};

type FormatDateOptions = {
  locale?: string;
  showTime?: boolean;
  timezone?: string;
  numeric?: boolean;
};

export function normalizeUnixTimestamp(value: unknown): number {
  if (value === null || value === undefined || value === '') return Number.NaN;

  const timestamp = Number(value);
  return Number.isFinite(timestamp) ? timestamp : Number.NaN;
}

export function getTimestampWithOffset(unixTimestamp: unknown, gmtOffset: unknown): number {
  const timestamp = normalizeUnixTimestamp(unixTimestamp);
  const offset = normalizeUnixTimestamp(gmtOffset);

  return Number.isFinite(timestamp) && Number.isFinite(offset)
    ? timestamp + offset
    : Number.NaN;
}

export function formatDateWithOffset(unixTimestamp: unknown, gmtOffset: unknown, options: FormatDateOptions = {}): string {
  return formatDate(getTimestampWithOffset(unixTimestamp, gmtOffset), options);
}

export function formatDate(unixTimestamp: number, { locale = 'da', showTime = false, timezone = 'UTC', numeric = false }: FormatDateOptions = {}): string {
  const resolvedLocale = localeMap[locale] ?? locale;
  const date = new Date(unixTimestamp * 1000);

  if (!Number.isFinite(unixTimestamp) || !Number.isFinite(date.getTime())) return '';

  // Dont delete this
  // return date.toLocaleDateString(locale, {
  //   weekday: 'short',
  //   day: '2-digit',
  //   month: 'short',
  //   year: 'numeric',
  // });

  // Use Intl.DateTimeFormat for better time zone handling
  const options: Intl.DateTimeFormatOptions = {
    timeZone: timezone,
    weekday: numeric ? undefined : 'short',
    day: '2-digit',
    month: numeric ? '2-digit' : 'short',
    year: 'numeric',
  };

  if (showTime) {
    const dateFormatter = new Intl.DateTimeFormat(resolvedLocale, options);
    const timeFormatter = new Intl.DateTimeFormat(resolvedLocale, {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: numeric ? 'h23' : undefined,
    });
    
    const timeSeparator = resolvedLocale === 'da-DK' ? ' kl. ' : ' ';
    const time = numeric
      ? timeFormatter.formatToParts(date).filter(part => part.type === 'hour' || part.type === 'minute').map(part => part.value).join(':')
      : timeFormatter.format(date);
    return `${dateFormatter.format(date)}${timeSeparator}${time}`;
  }

  const formatter = new Intl.DateTimeFormat(resolvedLocale, options);
  return formatter.format(date);
}
